import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmService } from '../../../pages/sm/services/sm.service';

@Component({
  selector: 'app-new-service-item-modal',
  templateUrl: './new-service-item-modal.component.html',
  styleUrls: ['./new-service-item-modal.component.css']
})
export class NewServiceItemModalComponent {
  @Input() lookupList:any
  @Input() woData: any
  formData: { [key: string]: any };
  constructor(private ngbActiveModal: NgbActiveModal, private smService: SmService,) { }

  ngOnInit() {
    this.formData = {};
    this.formData.Active = true;
  }

  closeModal () {
    this.ngbActiveModal.close()
  }

  addServiceItemAndClose () {
    this.smService.serviceItemInsertUpdate(
      -1,
      this.woData.SMCo,
      this.woData.ServiceSite,
      this.formData.ServiceItem,
      this.formData.ItemDescription,
      this.formData.Manufacturer,
      this.formData.Model,
      this.formData.YearManufactured,
      this.formData.Location,
      this.formData.SMTypeID,
      this.formData.SerialNumber,
      this.formData.Active,
      this.formData.ServiceItemSummary,
      null
    ).then((response) => {
      this.ngbActiveModal.close(response)
    })
  }
}
